var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"mb-0"},[_c('v-col',[_c('h1',[_vm._v("Аллергии пациента")])]),_c('v-col',{attrs:{"align":"right"}},[_c('modal',{attrs:{"depressed":"","icon":"add","title":"Добавить аллергию","name":"Аллергию","component":"add-allergy"}})],1)],1),_c('patient-header'),_c('allergy-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }